import { NgModule } from '@angular/core';
import { CommonModule, DatePipe, formatDate } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { UserLoginComponent } from './user-login/user-login.component';
import { HomePageComponent } from './home-page/home-page.component';
import { MainNavComponent } from './main-nav/main-nav.component';
import { TopNavComponent } from './top-nav/top-nav.component';
// import { LoadingSpinnerComponent } from './loading-spinner/loading-spinner.component';
// import { NotificationMessageComponent } from './notification-message/notification-message.component';
// import { UserProfileComponent } from './user-profile/user-profile.component';
// import { UserFormComponent } from './user-form/user-form.component';
// import { SsrPageComponent } from './ssr-page/ssr-page.component';
// import { ClientPageComponent } from './client-page/client-page.component';

// Angular material
import {MatSelectModule} from '@angular/material/select';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { MatTableModule } from '@angular/material/table';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatInputModule, MatNativeDateModule, MatListModule, MatDialogModule, MatChipsModule } from '@angular/material';
import { MatSortModule } from '@angular/material/sort';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatAutocompleteModule, MatCheckboxModule } from '@angular/material';
import { MatDatepickerModule } from '@angular/material/datepicker';
// import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';

// import { OperatorPageComponent } from './operator-page/operator-page.component';
// import { ProviderPageComponent } from './provider-page/provider-page.component';
// import { MaterialPageComponent } from './material-page/material-page.component';
// import { BuildingsitePageComponent } from './buildingsite-page/buildingsite-page.component';

// NG-Select
// import { NgSelectModule } from '@ng-select/ng-select';
// import { TaskPageComponent } from './task-page/task-page.component';
// import { OverlayModule } from '@angular/cdk/overlay';
import { BrowserAnimationsModule, NoopAnimationsModule } from '@angular/platform-browser/animations';
import { RoadbooksPageComponent } from './roadbooks-page/roadbooks-page.component';
import { UploadComponent } from './upload/upload.component';
// import { TaskpointPageComponent } from './taskpoint-page/taskpoint-page.component';
// import { TaskpointcategoryPageComponent } from './taskpointcategory-page/taskpointcategory-page.component';
import { FileSizePipe } from '../uploads/file-size.pipe';
import { DropZoneDirective } from '../uploads/drop-zone.directive';
// import { MomentDateModule } from '@angular/material-moment-adapter';
// import { ConfirmationdialogComponent } from './confirmationdialog/confirmationdialog.component';
// import { BuildingsitegalleryPageComponent } from './buildingsitegallery-page/buildingsitegallery-page.component';

// import { NgMasonryGridModule } from 'ng-masonry-grid';
// import { NgxGalleryModule } from 'ngx-gallery';
// import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
// import { MapaComponent } from './components/mapa/mapa.component';
// import { UsersPageComponent } from './users-page/users-page.component';
// import { AgmCoreModule } from '@agm/core';
// import { ShowerrordialogComponent } from './showerrordialog/showerrordialog.component';
import { MainPageComponent } from './main-page/main-page.component';
// import { TaskdetailPageComponent } from './taskdetail-page/taskdetail-page.component';
// import {MatGridListModule} from '@angular/material/grid-list';
// import { TaskhistoryPageComponent } from './taskhistory-page/taskhistory-page.component';
// import { VehiclePageComponent } from './vehicle-page/vehicle-page.component';
// import { MatSelectModule } from '@angular/material/select';
// import { FormatDatePipe } from '../pipes/format-date.pipe';

import { Angular2PrestaModule, Angular2PrestaConfiguration, Angular2PrestaService } from 'angular2-presta';
import { PrestashopService } from '../services/prestashop.service';
import { UsersPageComponent } from './users-page/users-page.component';
import { UsersDetailPageComponent } from './users-detail-page/users-detail-page.component';
import { ShowerrordialogComponent } from './showerrordialog/showerrordialog.component';
import { ConfigPageComponent } from './config-page/config-page.component';
import { ClientsPageComponent } from './clients-page/clients-page.component';
import { RoadbookSelectorComponent } from './roadbook-selector/roadbook-selector.component';
import { FolderGestorComponent } from './folder-gestor/folder-gestor.component';
import { FolderFormComponent } from './folder-form/folder-form.component';
import { NotificationsPageComponent } from './notifications-page/notifications-page.component';
import { QrDialogComponent } from './qr-dialog/qr-dialog.component';
import { QRCodeModule } from 'angularx-qrcode';
import { ConfirmationDialogComponent } from './confirmation-dialog/confirmation-dialog.component';
import { PrivacyPageComponent } from './privacy-page/privacy-page.component';

const a2pConfig: Angular2PrestaConfiguration = {
    apiKey: 'HSUKWQAL2H47S2C8IDU457BFK9GN1SKP',
    imageApiKey: 'OPTIONAL_IMAGE_API_KEY',
    shopUrl: 'https://vectornote.com/api/'
  };

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    MatTableModule,
    MatFormFieldModule,
    MatPaginatorModule,
    MatInputModule,
    MatSortModule,
    MatExpansionModule,
    MatIconModule,
    MatButtonModule,
    MatCardModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatNativeDateModule,
    BrowserAnimationsModule,
    NoopAnimationsModule,
    MatListModule,
    NgxMatSelectSearchModule,
    Angular2PrestaModule.forRoot(a2pConfig),
    MatDialogModule,
    MatCardModule,
    MatChipsModule,
    QRCodeModule
  ],
  declarations: [
    UserLoginComponent,
    HomePageComponent,
    MainNavComponent,
    TopNavComponent,
    RoadbooksPageComponent,
    MainPageComponent,
    UploadComponent,
    FileSizePipe,
    DropZoneDirective,
    UsersPageComponent,
    UsersDetailPageComponent,
    ShowerrordialogComponent,
    ConfigPageComponent,
    ClientsPageComponent,
    RoadbookSelectorComponent,
    FolderGestorComponent,
    FolderFormComponent,
    NotificationsPageComponent,
    QrDialogComponent,
    ConfirmationDialogComponent,
    PrivacyPageComponent,
  ],
  exports: [
    MainNavComponent,
    TopNavComponent,
  ],
  providers: [Angular2PrestaService, PrestashopService],
  entryComponents: [ShowerrordialogComponent]
})
export class UiModule { }
